/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRouteSquare2 = createReactComponent("route-square-2", "IconRouteSquare2", [
  ["path", { d: "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", key: "svg-0" }],
  ["path", { d: "M3 17h4v4h-4z", key: "svg-1" }],
  ["path", { d: "M17 3h4v4h-4z", key: "svg-2" }]
]);

export { IconRouteSquare2 as default };
//# sourceMappingURL=IconRouteSquare2.js.map
